module.exports = __webpack_public_path__ + "static/media/service-legacy.a3a8f38d.png";